import React from "react";
import classNames from "classnames";
import {ApolloError} from "@apollo/client";

import {Text} from "@unibuddy/patron";

import {ChatConversation} from "src/types/generated";
import {ErrorDisplay} from "shared/General/components/ErrorDisplay/ErrorDisplay";
import {useConversationsWithOpponents} from "shared/Inbox/hooks/useConversationsWithOpponents";

import {InboxEmpty} from "../InboxEmpty/InboxEmpty";
import InboxItem from "../InboxItem/InboxItem";
import s from "./InboxUI.pcss";

type InboxUIProps = {
    loading: boolean;
    conversations: ChatConversation[];
    showOnlineStatus: boolean;
    onOpenConversation: (id: string) => void;
    university: object;
    isExternal: boolean;
    error: ApolloError | undefined;
    className?: string;
};

const InboxUI = ({
    loading,
    conversations,
    showOnlineStatus,
    onOpenConversation,
    isExternal,
    error,
    className,
    university,
}: InboxUIProps) => {
    const {
        loading: conversationsLoading,
        error: conversationsError,
        conversations: conversationsWithOpponents,
    } = useConversationsWithOpponents(conversations);

    if (loading || conversationsLoading) {
        return <Text>Loading...</Text>;
    }

    const conversationItems = conversationsWithOpponents.map((conversation) => (
        <InboxItem
            key={conversation?.id}
            id={conversation?.sourceId}
            dataTestId={"inbox-item-id"}
            message={conversation?.lastMessage}
            unread={conversation?.unreadMessageCount}
            user={conversation?.opponent}
            onClick={() => {
                onOpenConversation(conversation?.sourceId);
            }}
            showOnlineStatus={showOnlineStatus}
            university={university}
            isExternal={isExternal}
        />
    ));

    const conversationsExist = conversationsWithOpponents.length !== 0;

    return (
        <ErrorDisplay error={error || conversationsError}>
            <div className={classNames(s.container as string, className)}>
                {!loading && !conversationsExist ? <InboxEmpty /> : null}
                {conversationItems}
            </div>
        </ErrorDisplay>
    );
};

export default InboxUI;
